module.exports = __webpack_public_path__ + "img/compIcon.59bea278.svg";